import { Box, Icon, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import MaterialReactTable, { MRT_ColumnDef, MRT_DensityState, MRT_ExpandedState, MRT_GroupingState, MRT_PaginationState, MRT_RowSelectionState, MRT_SortingState } from "material-react-table";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { IFilteringViewModel, ITableData } from "../../_common/interface/table";
import { ORANGE_COLOR } from "../../_const/color.const";
import { TABLE_FILTER } from "../../_const/tableFilter.const";

export function CompactTable(children: any, params: {
    isLoading?: boolean,
    columns?: MRT_ColumnDef<any>[],
    data?: any,
    children?: any
}) {

    return (
        <MaterialReactTable
            columns={params.columns}
            data={params.data}
            enableColumnResizing={false}
            enableGrouping={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableFullScreenToggle={false}
            enableStickyHeader
            enableHiding={false}
            enableStickyFooter
            manualFiltering={false}
            enableColumnFilterModes={false}
            enableColumnActions={false}
            enableFilters={false}
            enableEditing={false}
            enablePagination={false}
            enableTableFooter={false}
            enableRowActions={true}
            enableBottomToolbar={false}
            initialState={{
                showColumnFilters: false,
                showGlobalFilter: false,
                isLoading: params.isLoading,
                showProgressBars: params.isLoading,
                showToolbarDropZone: false,
                columnVisibility: { landingLineQuantity: false, },
                density: 'compact', //expand all groups by default
                pagination: { pageIndex: 0, pageSize: 200 },
                expanded: true,
            }}
            muiTableContainerProps={{ sx: { maxHeight: '400px', height: "400px" } }}
            muiToolbarAlertBannerChipProps={{ color: 'primary' }}

            {...children}
        />
    );

}
